<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control">
          <label class="label">Name</label>
          <input :class="{'input': true, 'is-danger': errors.has('name'), 'is-disabled': inProgress}" type="text" name="name" id="name" placeholder="Name" v-model="chain.name" v-validate data-vv-rules="required">
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </p>
        <p class="control">
          <label class="label">CNPJ</label>
          <input :class="{'input': true, 'is-danger': errors.has('cnpj'), 'is-disabled': inProgress}" type="text" name="cnpj" id="cnpj" placeholder="CNPJ" v-model.trim="chain.cnpj" v-validate="'required'">
          <span v-show="errors.has('cnpj')" class="help is-danger">{{ errors.first('cnpj') }}</span>
        </p>
        <p class="control">
          <label class="label">Supplier</label>
          <select :class="{'select': true, 'is-fullwidth': true, 'is-danger': errors.has('supplier'), 'is-disabled': edit }" v-model="chain.supplier" name="supplier" id="supplier" v-validate data-vv-rules="required|excluded:0" :disabled="edit">
            <option v-bind:value="0" value="0" selected>Select Supplier</option>
            <option v-for="supplier in providers" v-bind:value="supplier.id" v-if="supplier.name != ''">{{ supplier.name }}</option>
          </select>
          <span v-show="errors.has('supplier')" class="help is-danger">{{ errors.first('supplier') }}</span>
        </p>
        <p class="control">
          <label class="label">Payment</label>
          <select class="select is-fullwidth" v-model="chain.payment" name="payment" id="payment">
            <option value="1">Billed</option>
            <option value="2">Anticipated</option>
            <option value="3">Billed/Anticipated</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Rule</label>
          <select :class="{'select': true, 'is-fullwidth': true}" v-model="chain.rule_id" name="rule" id="rule" :disabled="parseInt(context.$store.state.config.user.level) < 3">
            <option value="">None</option>
            <option v-for="rule in rules" v-bind:value="rule.id" v-if="rule.name.trim() != ''">{{ rule.name }}</option>
          </select>
        </p>
        <p class="control" v-show="parseInt(context.$store.state.config.user.level) < 4">
          <label class="checkbox">
            <input type="checkbox" v-model="chain.po">
            Generate PO
          </label>
        </p>
        <p class="control">
          <label class="label">Receipt Email</label>
          <input :class="{'input': true, 'is-danger': errors.has('receipt_email'), 'is-disabled': inProgress}" type="email" name="receipt_email" id="receipt_email" placeholder="Email" v-model="chain.receipt_email" v-validate="'email'">
          <span v-show="errors.has('receipt_email')" class="help is-danger">{{ errors.first('receipt_email') }}</span>
        </p>
        <p class="control is-expanded" v-if="edit">
          <label class="label">Contract
            <a class="button button-table is-small" @click="getFile('contract')" v-if="parseInt(this.chain.contract) === 1" >
              <i class="fa fa-file"></i>
            </a>
          </label>
          <input type="file" id="contract" ref="invoice" v-on:change="handleFileUploadContract()" :disabled="parseInt(context.$store.state.config.user.level) < 3"/>
        </p>
        <p class="control is-expanded" v-if="edit">
          <label class="label">Bank Data
            <a class="button button-table is-small" @click="getFile('bank')" v-if="parseInt(this.chain.bank) === 1">
              <i class="fa fa-file"></i>
            </a>
          </label>
          <input type="file" id="bank_data" ref="bank_data" v-on:change="handleFileUploadBankData()" :disabled="parseInt(context.$store.state.config.user.level) < 3"/>
        </p>
        <p class="control is-expanded" v-if="edit">
          <label class="label">Form Card
            <a class="button button-table is-small" @click="getFile('card')" v-if="parseInt(this.chain.card) === 1">
              <i class="fa fa-file"></i>
            </a>
          </label>
          <input type="file" id="form_card" ref="form_card" v-on:change="handleFileUploadFormCard()" :disabled="parseInt(context.$store.state.config.user.level) < 3"/>
        </p>
        <p class="control">
          <label class="label">Observation</label>
          <textarea :class="{'textarea': true, 'is-danger': errors.has('observation')}" name="observation" id="observation" placeholder="" v-model="chain.observation"></textarea>
          <span v-show="errors.has('observation')" class="help is-danger">{{ errors.first('observation') }}</span>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-loading': inProgress, 'is-disabled': errors.any()}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import babelPolyfill from 'babel-polyfill'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      chain_id: {
        type: Number
      },
      edit: {
        type: Boolean
      }
    },
    data () {
      return {
        chain: {
          id: '',
          name: '',
          cnpj: '',
          supplier: 0,
          observation: '',
          hotels: [],
          payment: 0,
          receipt_email: '',
          po: false,
          rule_id: 1,
          contract: 0
        },
        hotel: null,
        providers: [],
        hotels: [],
        rules: [],
        inProgress: false,
        stage: 1,
        error: '',
        file: null,
        file2: null,
        file3: null
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.edit) {
          this.loadData()
        }
        this.loadProviders()
        this.loadRules()
      })
    },
    methods: {
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      getFile (file) {
        window.location.href = this.context.$store.state.config.apiURL + '/chains/file/' + file + '/' + this.chain.id
      },
      loadProviders () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/providers/all').then((response) => {
          this.providers = response.body
          document.body.appendChild(this.$el)
        }, (response) => {

        })
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/chains/' + this.chain_id).then((response) => {
          this.chain.id = response.body.id
          this.chain.name = response.body.name
          this.chain.supplier = response.body.provider_id
          this.chain.observation = response.body.observation
          this.chain.payment = response.body.payment
          this.chain.rule_id = response.body.rule_id
          this.chain.contract = response.body.contract
          this.chain.bank = response.body.bank
          this.chain.card = response.body.card
          this.chain.po = response.body.po
          this.chain.receipt_email = response.body.receipt_email
          if (response.body.cnpj) {
            this.chain.cnpj = response.body.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
          }
        }, (response) => {
        })
      },
      handleFileUploadContract () {
        let ext = this.$refs.invoice.files[0].type
        if (ext !== 'application/pdf') {
          this.file = null
          this.$refs.invoice.value = ''
          this.error = 'Select a PDF file!'
        } else {
          this.file = this.$refs.invoice.files[0]
          this.error = ''
        }
      },
      handleFileUploadBankData () {
        let ext = this.$refs.bank_data.files[0].type
        if (ext !== 'application/pdf') {
          this.file2 = null
          this.$refs.bank_data.value = ''
          this.error = 'Select a PDF file!'
        } else {
          this.file2 = this.$refs.bank_data.files[0]
          this.error = ''
        }
      },
      handleFileUploadFormCard () {
        let ext = this.$refs.form_card.files[0].type
        if (ext !== 'application/pdf') {
          this.file3 = null
          this.$refs.form_card.value = ''
          this.error = 'Select a PDF file!'
        } else {
          this.file3 = this.$refs.form_card.files[0]
          this.error = ''
        }
      },
      async submitFileContract () {
        if (this.file !== null) {
          let data = new window.FormData()
          data.append('file', this.file)
          data.append('chain_id', this.chain.id)
          this.context.$http.post(this.context.$store.state.config.apiURL + '/chains/files/contract', data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
            return true
          }, (response) => {
            return true
          })
        } else {
          return true
        }
      },
      async submitFileBankData () {
        if (this.file2 !== null) {
          let data = new window.FormData()
          data.append('file', this.file2)
          data.append('chain_id', this.chain.id)
          this.context.$http.post(this.context.$store.state.config.apiURL + '/chains/files/bank', data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
            return true
          }, (response) => {
            return true
          })
        } else {
          return true
        }
      },
      async submitFileFormCard () {
        if (this.file3 !== null) {
          let data = new window.FormData()
          data.append('file', this.file3)
          data.append('chain_id', this.chain.id)
          this.context.$http.post(this.context.$store.state.config.apiURL + '/chains/files/card', data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
            return true
          }, (response) => {
            return true
          })
        } else {
          return true
        }
      },
      async save () {
        this.$validator.validateAll().then(async () => {
          this.inProgress = true
          this.error = ''
          if (!this.edit) {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/chains', this.chain).then((response) => {
              this.inProgress = false
              this.stage = 2
              this.chain.id = response.body.id
              this.close(false, {ok: true, message: this.chain.name + ' successfully created'})
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          } else {
            await this.submitFileContract()
            await this.submitFileBankData()
            await this.submitFileFormCard()
            this.context.$http.post(this.context.$store.state.config.apiURL + '/chains/' + this.chain.id, this.chain).then((response) => {
              this.inProgress = false
              this.chain.id = response.body.id
              this.close(false, {ok: true, message: this.chain.name + ' successfully saved'})
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          }
        })
      },
      loadRules () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/invoice_payment_rules/payment').then((response) => {
          this.rules = response.body
          document.body.appendChild(this.$el)
        }, (response) => {

        })
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
      babelPolyfill
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .modal-card-body {
    min-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// Chain.vue?4c3ae07a